module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    attrs: {
      "id": "app"
    }
  }, [(_vm.brand === 'filzfelt') ? _c('header-filzfelt') : _vm._e(), _vm._v(" "), (_vm.brand === 'spinneybeck') ? _c('header-spinneybeck') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('router-view')], 1), _vm._v(" "), (_vm.brand === 'filzfelt') ? _c('footer-filzfelt') : _vm._e(), _vm._v(" "), (_vm.brand === 'spinneybeck') ? _c('footer-spinneybeck') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d2cf838"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/App.vue
// module id = 561
// module chunks = 1